/**
 * @desc 类目列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmCategoryListResponseDto>>;
export function request(
  body: defs.basics.PlmCategoryRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/category/findList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
